import React from "react";
import Render from "../../utilities/Render";

class HelpfulFeedback extends React.Component {
  constructor(props) {
    super();

    this.state = {
      feedbackActive: " ",
      wasHelpful: " ",
      hasSubmitted: " ",
      afterSubmit: " ",
      feedback: " "
    };
  }

  yesFeedback = () => {
    this.showFeedback();

    //gaTracker("send", "event", "feedback", "yes", "feedback goes here");
    this.setState({
      wasHelpful: "yes",
      noActive: " ",
      yesActive: "active"
    });
  };

  noFeedback = () => {
    this.showFeedback();
    //gaTracker("send", "event", "feedback", "no", "feedback goes here");

    this.setState({
      wasHelpful: "no",
      yesActive: " ",
      noActive: "active"
    });
  };

  showFeedback = () => {
    this.setState({ feedbackActive: "show-feedback" });
  };

  hideFeedback = event => {
    event.preventDefault();
    this.setState({
      feedbackActive: "hide-feedback",
      yesActive: " ",
      noActive: " "
    });
  };

  submitFeedback = event => {
    event.preventDefault();
    this.setState({
      hasSubmitted: "show-thankyou",
      feedbackActive: "hide-feedback",
      afterSubmit: "hide-selection",
      feedback: event.target.value
    });
    var message = document.querySelector("#feedback-message").value;
    gaTracker(
      "SITETracker.send",
      "event",
      "formtracking",
      "feedback form",
      "page-helpful=" + this.state.wasHelpful + "&comment=" + message
    );
  };

  feedbackChange = event => {
    event.preventDefault();
    this.setState({
      feedback: event.target.value
    });
  };

  render() {
    return (
      <div id="helpful-feedback">
        <div className="container-fluid">
          <div
            className={"row was-this-helpful" + " " + this.state.afterSubmit}
          >
            <div className="col-sm-12 col-md-8 heading">
              <h2 className="no-summary">Was this helpful?</h2>
            </div>

            <div className="col-sm-12 col-md-4 selection">
              <button
                className={this.state.yesActive}
                onClick={this.yesFeedback}
                value="Yes"
              >
                Yes
              </button>{" "}
              <button
                className={this.state.noActive}
                onClick={this.noFeedback}
                value="No"
              >
                No
              </button>
            </div>
          </div>

          <div className={"row feedback" + " " + this.state.feedbackActive}>
            <div className="col-12 feedback-form">
              <form method="GET">
                <input
                  className="feedback-btn"
                  type="hidden"
                  value={this.state.wasHelpful}
                />
                <label htmlFor="feedback-message">
                  <h2 className="no-summary">Any comments? (optional)</h2>
                </label>
                <textarea
                  id="feedback-message"
                  value={this.state.feedback}
                  name="feedback"
                  onChange={this.feedbackChange}
                ></textarea>
                <input
                  className="submit"
                  type="submit"
                  value="Send feedback"
                  onClick={this.submitFeedback}
                />
                <button className="cancel" onClick={this.hideFeedback}>
                  Cancel
                </button>
              </form>
            </div>
          </div>

          <div className={"row thank-you" + " " + this.state.hasSubmitted}>
            <div className="col-12">
              Thank you, your feedback is valuable to us.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Render.Component("#helpful-feedback-react", null, HelpfulFeedback);

export default HelpfulFeedback;
